import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-address-component',
  templateUrl: './address-component.component.html',
  styleUrls: ['./address-component.component.css'],
})
export class AddressComponentComponent implements OnInit {
  private apiKey = environment.apiKey_loqate;

  suggestions: any[] = [];
  isDisabledCity: boolean = true;

  @Input('addressForm') addressForm!: FormGroup;
  @Input('isLoading') isLoading!: boolean;
  @Input() showAddressFields: boolean = true;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  onQueryChange(e: any) {
    const query = `${e?.query || ''}`.trim();

    if (query === '') {
      this.suggestions = [];
      return;
    }

    this.getSuggestions(query).subscribe((data: any) => {
      this.suggestions = [];
      data?.Items.forEach((suggestion: any) => {
        this.suggestions.push({
          label: suggestion?.Text,
          id: suggestion?.Id,
          type: suggestion?.Type,
        });
      });
      this.addressForm.patchValue({
        country: '',
        city: '',
        state: '',
        zip_code: '',
      });
    });
  }

  getSuggestions(query: string) {
    const url = `https://api.addressy.com/Capture/Interactive/Find/v1.00/json3ex.ws?key=${this.apiKey}&text=${query}&Countries=US`;
    return this.http.get(url);
  }

  // to show (*) in html if field is required
  isControlRequired(control: any): boolean {
    return control?.hasValidator(Validators.required);
  }

  onSelected(e: any) {
    this.suggestions = [];
    // in case type is address (mean more details)
    if (e?.type == 'Address') {
      const detailsUrl = `https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws?key=${this.apiKey}&Id=${e?.id}`;
      this.http.get(detailsUrl).subscribe((res1: any) => {
        const item = res1?.Items[0];
        this.setAddressFields(item);
      });
    } else {
      // in case type is container (mean need more details)
      const addressTypeUrl = `https://api.addressy.com/Capture/Interactive/Find/v1.00/json3ex.ws?key=${this.apiKey}&text=${e?.label}&Countries=US&Container=${e?.id}`;
      this.http.get(addressTypeUrl).subscribe((res: any) => {
        this.addressForm.controls['street_address'].setValue({
          label: res?.Items[0]?.Text,
          id: e?.id,
          type: e?.type,
        });
        const detailsUrl = `https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws?key=${this.apiKey}&Id=${res?.Items[0]?.Id}`;
        this.http.get(detailsUrl).subscribe((res1: any) => {
          const item = res1?.Items[0];
          this.setAddressFields(item);
        });
      });
    }
  }

  private setAddressFields(item: any): void {
    if (!item) return;

    this.addressForm.patchValue({
      country: item.CountryName,
      city: item.City,
      state: item.ProvinceCode,
      zip_code: item.PostalCode,
    });

    const streetAddressControl = this.addressForm.get('street_address');
    const streetAddressValue = streetAddressControl?.value;
    let street =
      typeof streetAddressValue === 'object'
        ? streetAddressValue?.label || ''
        : streetAddressValue || '';
    const toRemove = [
      item.CountryName,
      item.City,
      item.ProvinceCode,
      item.PostalCode,
    ];

    toRemove.forEach((val) => {
      if (val) street = street.replace(val, '');
    });

    street = street.replace(/,+/g, ',').replace(/,\s*$/, '').trim();

    this.addressForm
      .get('street_address')
      ?.patchValue({
        ...(typeof streetAddressValue === 'object' ? streetAddressValue : {}),
        label: street,
      });
  }
}

/* 
  steps to integrate address component to your component

  1-create addressGroup in your form
    ********ex:*********
    formGroupTest:FormGroup = new FormGroup({
      formAddress: new FormGroup({
        street_address:new FormControl('',[Validators.required]),
        country:new FormControl('',[]),
        state:new FormControl('',[]),
        city:new FormControl('',[]),
        zip_code:new FormControl('',[]),
      })
    }) 

  3- declare formAddress in your component
    ********ex:********
      get formAddress():FormGroup{
        return this.formGroupTest.get('formAddress') as FormGroup
      }


  2- call address component in your component(.html)
    *********ex:********
      <form action="" [formGroup]="formGroupTest">
          <app-address-component [addressForm]="formAddress">

          </app-address-component>
      </form>
    
*/
